import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ClearPathLogo from '../components/ClearPathLogo';
import SampleBriefCard from '../components/SampleBriefCard';

/** Public demo page — no auth, mirrors the SharePage read-only pattern. */
export default function DemoPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F7]">
      {/* Header */}
      <div className="bg-[#4A2D5E] px-6 py-4 flex items-center justify-between">
        <ClearPathLogo variant="white" size="sm" />
        <div className="text-right">
          <div className="font-serif text-white text-sm">The Morning Brief</div>
          <div className="font-sans text-white/60 text-xs">Live demo</div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-10">
        <div className="mb-8 text-center">
          <h1 className="font-serif text-3xl text-[#2D2A2E] leading-snug">
            This is what lands in your inbox every morning
          </h1>
          <p className="font-sans text-sm text-[#6B6670] mt-2 max-w-md mx-auto leading-relaxed">
            One short brief. A few specific moves. Each one worth real money.
          </p>
        </div>

        <SampleBriefCard />

        {/* Explainer strip */}
        <div className="mt-6 bg-[#4A2D5E]/5 border border-[#4A2D5E]/10 rounded-[14px] px-5 py-4">
          <p className="font-sans text-sm text-[#2D2A2E] leading-relaxed text-center">
            This brief was generated this morning by ClearPath's engine from a modeled year of
            café data, not a customer's — yours would look like this by tomorrow.
          </p>
        </div>

        {/* CTAs */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate('/auth')}
            className="inline-flex items-center gap-2 bg-[#4A2D5E] text-white hover:bg-[#3D254D] rounded-[8px] font-sans font-medium px-6 py-3 text-sm transition-all shadow-sm hover:shadow-md hover:-translate-y-px"
          >
            Start free
            <ArrowRight size={15} strokeWidth={2} />
          </button>
          <button
            onClick={() => navigate('/')}
            className="bg-white border border-[#E6E2DE] text-[#6B6670] hover:border-[#4A2D5E] hover:text-[#4A2D5E] rounded-[8px] font-sans font-medium px-6 py-3 text-sm transition-all"
          >
            Learn more
          </button>
        </div>

        <p className="font-sans text-xs text-[#6B6670] text-center mt-10">
          Powered by <span className="font-medium text-[#4A2D5E]">ClearPath</span> · Read-only demo · No account required
        </p>
      </div>
    </div>
  );
}
